export default "__VITE_ASSET__Cf7ndbSQ__"